function LoginForm() {
  
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      let redirectAuthUrl;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/ebay/login`);
      if (!response.ok) throw new Error('Failed auth login');
      const data = await response.json();
      redirectAuthUrl = data.authUrl;
      window.location.href = redirectAuthUrl;
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h3>Login With eBay Account</h3>
      <form>
        <button type="button" onClick={handleLogin}>Login with eBay</button>
      </form>
    </div>
  );
}

export default LoginForm;
